import { Component, OnInit, Inject} from '@angular/core';


import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FinanzasService } from 'app/finanzas/finanzas.service';
import { Bitacora, Query } from 'app/finanzas/entidades';
import { isNumber } from 'util';
import Swal from 'sweetalert2';
import { FormGastos } from '../form-bitacora/gastos/form-gastos.component';


@Component({
    selector: 'app-relGastos',
    styleUrls: ['./relGastos.component.css'],
    templateUrl: './relGastos.component.html' 
})

export class RelGastos implements OnInit{

    list_gastos;    // Array que guarda los gastos filtrados por mes anio y mes consultados 

    lista = {}
    seleccionados = {};
    isDisabled=false;

    movimiento: Bitacora = new Bitacora();
    areas;   // Array que contiene
    puc;     // Array que guarda

    // datos id_empresa y anio 
    id_empresa = this.datos.empresa;
    anio = this.datos.anio;
    mes = this.datos.mes


    constructor(private service: FinanzasService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<RelGastos>,
        @Inject(MAT_DIALOG_DATA) private datos) { 
            this.list_gastos = []

            this.movimiento['comprobante'] = this.datos.idComprobante;
        }

    ngOnInit(): void {
        console.log(this.datos)
    
        this.service.gastos(this.id_empresa, this.anio, this.mes)
            .subscribe((resp ) => {
                this.list_gastos = resp 
                console.log(resp)
            });
        
        this.tablaArea();
        this.tablaPuc();
        
    }


    private tablaArea() {
        this.service.getArea().subscribe((resp) => {
            this.areas = resp;
        })
    }

    private tablaPuc() {
        this.service.getPuc(this.id_empresa).subscribe((resp) => {
            this.puc = resp
        })
    }

    // mira si la casilla fue seleccionada o no 
    validarCheckbox(comprobante){
        if( isNumber(comprobante)){
            return true
        }
        return false
    }

    form_bitacora_gastos( id_gasto): void {
        const dialogRef = this.dialog.open(FormGastos, {
            width: '500px',
            data: {                
                id_gasto,
                comprobante : this.datos.idComprobante, 
                mes : this.mes, 
                anio: this.anio,
                empresa: this.id_empresa,
                gastos: this.list_gastos,
                areas: this.areas,
                puc: this.puc,                
                mostrar: true,
            }
        });

        dialogRef.afterClosed().subscribe(result => {            
            this.movimiento = result;
            this.movimiento['comprobante'] = this.datos.idComprobante;
            
            this.actualizar();
        });
    }

        
    // trae los gastos que se seleccionen el modal Relgastos 
    obtenerSeleccionados = function () {
        let arreglo = $.map(
            this.seleccionados, function (value, index) { return [index]; }
        );
        

        // trae el servicio de la bd paa agregarle a cada a gasto su comprobante 
        for(const i of arreglo) {                
            this.service.relacionGastos( this.movimiento, i)
                .subscribe( (resp:Query ) => {
                    this.query = resp.affectedRows }
        )}

        // se condiciona la respuesta para mirar si si se agrego correctamente
        if(this.query != 0){
            Swal.fire({
                type: 'success',
                title: 'El Comprobante se relaciono correctamente'
            })
        }
    }


    actualizar() {
        if (this.movimiento['id_gasto'] != undefined) {
            this.service.actualizarRegistro(this.movimiento, this.movimiento['id_gasto'])
                .subscribe((status: Query) => {
                    const affectedRows = status.affectedRows
                    if (affectedRows != 0) {
                        Swal.fire({
                            type: 'success',
                            title: 'El registro fue actualizado'
                        })
                    }
                    else {
                        Swal.fire({
                            type: 'error',
                            title: 'El registro no se pudo guardar',
                        })
                    }    
                })
        }
    }  

}